module.exports = __webpack_public_path__ + "img/slphouse_main6.b8c01f6d.png";